import { render, staticRenderFns } from "./DynamicColumnChart_.vue?vue&type=template&id=4444e4ca&scoped=true&"
import script from "./DynamicColumnChart_.vue?vue&type=script&lang=ts&"
export * from "./DynamicColumnChart_.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicColumnChart_.vue?vue&type=style&index=0&id=4444e4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4444e4ca",
  null
  
)

export default component.exports